<template>
  <div class="car-details" v-loading="oLoading.detail">
    <QS-scroller-box :stepsOpt="stepsOpt">
      <QS-h3-title>
        <template slot="title">
          <el-button
            v-if="
              carMessage == 2 &&
                carState !== 5 &&
                carInfo.exitOperationState !== 1 &&
                judgePermission('vehicle_licences_list_submit')
            "
            @click="getcarAuditRecord"
            type="primary"
            size="mini"
            >车辆信息提交审核</el-button
          >
          <el-button
            v-if="
              (carMessage == 1 || carMessage == 2 || carMessage == 4) &&
                carInfo.exitOperationState !== 1 &&
                judgePermission('vehicle_licences_list_edit')
            "
            @click="goEdit"
            type="primary"
            size="mini"
            >编辑证照信息</el-button
          >
        </template>
        <div class="splitline" />
      </QS-h3-title>
      <el-collapse v-model="activeNames" @change="handleChange">
        <el-collapse-item title="行驶证信息" name="car_license_info">
          <div class="scroll-box-item">
            <div class="img-item">
              <div class="label">行驶证照片:</div>
              <div class="content">
                <div
                  class="item"
                  v-for="(item, index) in imageData.drivingMain"
                  :key="'drivingMain' + index"
                >
                  <EnlargeImg :imgSrc="item" />
                  <p>行驶证主页</p>
                </div>
                <div
                  class="item"
                  v-for="(item, index) in imageData.drivingBack"
                  :key="'drivingBack' + index"
                >
                  <EnlargeImg :imgSrc="item" />
                  <p>行驶证副页</p>
                </div>
                <div
                  class="item"
                  v-for="(item, index) in imageData.viceImg"
                  :key="'viceImg' + index"
                >
                  <EnlargeImg :imgSrc="item" />
                  <p>副页背面</p>
                </div>
              </div>
            </div>
            <column-box
              :source="carLicenseInfo"
              :list="carLicenseInfoKeyList"
              :labelWidth="130"
            ></column-box>
          </div>
        </el-collapse-item>
        <el-collapse-item title="行驶证领取信息" name="car_license_receive">
          <div>
            <column-box
              :source="carLicenseInfo"
              :list="carLicenseReceiveKeyList"
              :labelWidth="130"
            ></column-box>
          </div>
        </el-collapse-item>
        <el-collapse-item title="网约车证信息" name="car_transport_info">
          <div class="scroll-box-item">
            <div class="img-item">
              <div class="label">网约车证照片:</div>
              <div class="content" v-if="imageData.network.length">
                <div class="item">
                  <EnlargeImg :imgSrc="imageData.network" />
                  <p>网约车证</p>
                </div>
              </div>
            </div>
            <column-box
              :source="carTransportLicense"
              :list="carTransportLicenseKeyList"
              :labelWidth="130"
            ></column-box>
          </div>
        </el-collapse-item>
        <el-collapse-item title="登记证信息" name="car_register_info">
          <div class="scroll-box-item">
            <div class="img-item">
              <div class="label">登记证照片:</div>
              <div class="content" v-if="imageData.register.length">
                <div class="item">
                  <EnlargeImg :imgSrc="imageData.register" />
                  <p>登记证</p>
                </div>
              </div>
              <div class="content ml16" v-if="imageData.registrationImg.length">
                <div
                  class="item"
                  v-for="(item, index) in imageData.registrationImg"
                  :key="'registrationImg' + index"
                >
                  <EnlargeImg :imgSrc="item" />
                  <p>登记证副页</p>
                </div>
              </div>
            </div>
            <column-box
              :source="carRegisterLicense"
              :list="carRegisterLicenseKeyList"
              :labelWidth="130"
            ></column-box>
          </div>
        </el-collapse-item>
      </el-collapse>
    </QS-scroller-box>
  </div>
</template>

<script>
import CARDICT from '@/store/dict/carDict.js'
import {
  getCarDetails,
  getcarAuditRecord,
  getCarModelList,
} from '@/api/domain/cars'
import EnlargeImg from '@/components/EnlargeImg'

export default {
  components: {
    EnlargeImg,
  },
  data() {
    return {
      oLoading: {
        detail: false,
      },
      carId: '',
      stepsOpt: {
        anchorName: '.demo-section',
      },
      imageData: {
        drivingMain: [],
        drivingBack: [],
        network: [],
        register: [],
        viceImg: [], // 行驶证副页背面照片
        registrationImg: [], // 登记证副页
      },

      modelList: [], // 车型
      carMessage: '',
      carState: '', // 车辆状态
      carInfo: {},

      carLicenseInfoKeyList: [
        { key: 'originalPlateNo', name: '原车牌' },
        { key: 'type', name: '车辆类型' },
        { key: 'property', name: '车辆属性' },
        { key: 'usage', name: '使用性质' },
        { key: 'usageDate', name: '车辆性质变更时间' },
        { key: 'issueOrgan', name: '发证机关' },
        { key: 'engineNo', name: '发动机号' },
        { key: 'issueDate', name: '行驶证发证日期' },
        { key: 'seats', name: '核定载人数' },
        { key: 'inspectDate', name: '年检有效期' },
        { key: 'scrapDate', name: '强制报废日期' },
        { key: 'drivingLicenseNo', name: '档案编号' },
        { key: 'totalMass', name: '总质量' },
        { key: 'kerbWeight', name: '整备质量' },
        { key: 'approvedLoad', name: '核定载质量' },
        { key: 'overallSize', name: '外廓尺寸' },
        { key: 'tractionMass', name: '准牵引总质量' },
        { key: 'licenseRemarks', name: '行驶证备注' },
        { key: 'owner', name: '所有人' },
        { key: 'ownerAddress', name: '住址' },
        { key: 'registDate', name: '注册日期' },
      ],
      carLicenseInfo: {},
      carLicenseReceiveKeyList: [
        { key: 'receiveDate', name: '领取日期' },
        { key: 'receivePlace', name: '领取地点' },
        { key: 'licenseReceiver', name: '签收人' },
      ],
      carTransportLicenseKeyList: [
        { key: 'transportLicenseNo', name: '交运管许可字号' },
        { key: 'bizScope', name: '经营范围' },
        { key: 'issueOrgan', name: '签发机关' },
        { key: 'registDate', name: '登记日期' },
        { key: 'effectDate', name: '有效期开始日期' },
        { key: 'expiryDate', name: '有效期截止日期' },
      ],
      carTransportLicense: {},
      carRegisterLicenseKeyList: [
        { key: 'registNo', name: '登记编号' },
        { key: 'acquisitionMode', name: '车辆获得方式' },
        { key: 'registOrgan', name: '发证机关' },
        { key: 'productionDate', name: '出厂日期' },
        { key: 'issueDate', name: '发证日期' },
      ],
      carRegisterLicense: {},

      // 当前展开面板
      activeNames: [
        'car_license_info',
        'car_license_receive',
        'car_transport_info',
        'car_register_info',
      ],
    }
  },
  props: {
    id: {
      type: [String, Number],
      default: 0,
    },
  },
  mounted() {
    const { id } = this
    if (id) {
      this.carId = id
    }
    this.getCarDetails()
    // 车型
    this.getCarModelList()
  },
  methods: {
    handleChange() {},
    // 车型
    async getCarModelList() {
      try {
        const { code, data } = await getCarModelList({
          state: 1,
        })
        if (code === 1) {
          this.modelList = data
        } else {
          this.$message.error('获取车型列表失败')
        }
      } catch (error) {
        this.$message.error('获取车型列表失败')
      }
    },

    // 编辑证照
    goEdit() {
      this.$router.push({
        path: '/vehicle/licences/edit',
        query: {
          id: this.carId,
        },
      })
    },
    // 获取车辆详情
    async getCarDetails() {
      this.oLoading.detail = true
      const { code, data } = await getCarDetails({
        id: this.carId,
      })
      this.oLoading.detail = false
      if (code === 1) {
        this.carInfo = Object.assign({}, data.carInfo)
        // 行驶证信息
        this.carLicenseInfo = Object.assign({}, data.carLicenseInfo)

        if (data.carInfo) {
          // 车型
          if (this.modelList.length) {
            this.carLicenseInfo.modelName = this.getCarModelName(
              data.carInfo.modelId,
            )
          }
          // 颜色
          this.carLicenseInfo.color = CARDICT.CAR_COLOR_DICT()[
            data.carInfo.color
          ]
          this.carLicenseInfo.registDate = data.carInfo.registDate
        }
        if (data.carLicenseInfo) {
          // 使用性质
          this.carLicenseInfo.usage = CARDICT.CAR_USE_DICT()[
            this.carLicenseInfo.usage
          ]

          this.carLicenseInfo.owner = data.carLicenseInfo.owner
          this.carLicenseInfo.ownerAddress = data.carLicenseInfo.ownerAddress
          // 车辆属性
          this.carLicenseInfo.property = CARDICT.CAR_ATTRIBUTE_DICT()[
            this.carLicenseInfo.property
          ]
          // 车辆类型
          this.carLicenseInfo.type = CARDICT.CAR_TYPE_DICT()[
            this.carLicenseInfo.type
          ]
          // 行驶证照片
          this.imageData.drivingMain = this.getEchoUploadFileData(
            data?.carLicenseInfo?.drivingLicense,
          )
          this.imageData.drivingBack = this.getEchoUploadFileData(
            data?.carLicenseInfo?.drivingSubLicense,
          )
          // 行驶证副页背面照片
          this.imageData.viceImg = this.getEchoUploadFileData(
            data?.carLicenseInfo?.subLicenseBackPhoto,
          )
        }

        if (
          data &&
          data.carTransportLicense &&
          data.carTransportLicense.expiryDate
        ) {
          data.carTransportLicense.expiryDate =
            data.carTransportLicense.expiryDate === '2099-09-09'
              ? '长期有效'
              : data.carTransportLicense.expiryDate
        }
        this.carTransportLicense = data.carTransportLicense
          ? data.carTransportLicense
          : {}
        this.carRegisterLicense = data.carRegistCertInfo
          ? data.carRegistCertInfo
          : {}

        // 车辆基本状态信息
        this.carMessage = Number(data.carInfo.basicItemState)

        this.carState = Number(data.carInfo.carState)

        // 网约车证照片
        if (data.carTransportLicense && data.carTransportLicense.photo) {
          this.imageData.network =
            this.getEchoUploadFileData(data.carTransportLicense.photo)?.[0] ||
            ''
        }

        // 登记证照片
        if (data.carRegistCertInfo && data.carRegistCertInfo.photo) {
          this.imageData.register =
            this.getEchoUploadFileData(data.carRegistCertInfo.photo)?.[0] || ''
        }
        // 登记证副页详情
        if (
          data.carRegistCertInfo &&
          data.carRegistCertInfo.subRegisterCertPhotos
        ) {
          const photos = this.getEchoUploadFileData(
            data.carRegistCertInfo.subRegisterCertPhotos,
          )
          this.imageData.registrationImg = Array.isArray(photos) ? photos : []
        }
      }
    },
    async getcarAuditRecord() {
      /// 获取审核状态
      const { code, data } = await getcarAuditRecord({
        carId: this.carId,
        type: this.carInfo.basicItemState,
      })
      if (code === 1 && data) {
        this.getCarDetails()
      }
    },

    getCarModelName(id) {
      const arr = this.modelList.filter((item) => item.modelId === id)
      if (arr.length) {
        return arr?.[0].modelName
      } else {
        return ''
      }
    },
  },
}
</script>

<style scoped lang="scss">
.car-details {
  height: 100%;
  ::v-deep .el-collapse {
    border-top: none;
  }
  ::v-deep .el-collapse-item__content {
    padding-top: 25px;
  }
  ::v-deep .el-collapse-item__wrap {
    border-bottom: none;
  }
  ::v-deep .el-collapse-item__arrow.is-active {
    transform: rotate(-90deg);
  }
  ::v-deep .el-collapse-item__arrow {
    transform: rotate(90deg);
  }
  .img-item {
    display: flex;
    margin-bottom: 40px;
    // min-height: 105px;
    .label {
      padding-right: 12px;
      width: 130px;
      text-align: right;
      box-sizing: border-box;
    }
    .content {
      max-width: 480px;
      display: flex;
      flex-wrap: wrap;
      .item {
        margin-left: 16px;
        width: 80px;
        height: 80px;
        &:nth-child(5n + 1) {
          margin-left: 0;
        }
        &:nth-child(n + 6) {
          margin-top: 6px;
        }
      }
      p {
        white-space: nowrap;
        text-overflow: ellipsis;
        color: #969799;
        line-height: 25px;
        overflow: hidden;
        text-align: center;
      }
    }
  }
}
</style>
